// extracted by mini-css-extract-plugin
export default {"app":"Tab5_app__ulJ+j"};